<template>
    <div class="ibox">
        <div class="ibox-title ibox-grey">
            <h4 v-if="analyzeType == 'sell'">{{ __('list_choosen_sell_positions') }}</h4>
            <h4 v-else>{{ __('list_choosen_buy_positions') }}</h4>
            <div class="ibox-tools">
                <a href="#" @click.prevent="toggleVisible()"><i class="fas fa-cogs"></i></a>
                <button-open-help-modal :in-extra-div="false" :helpName="analyzeType == 'sell'? 'ASA-002' : 'ASB-002'"/>
            </div>

        </div>
        <div class="ibox-content">
                    <!-- uklad jak listy standardowe (bez table-fixed): kolumny wg tresci, przypiecia
                         z user_columns ustawia public/js/table-layout.js (szuka #main-table) -->
                    <table class="table table-striped" id="main-table">
                        <thead>
                        <tr>
                            <th class="th-first w-40 sticky-header"><input type="checkbox" id="check-all" @click="toggleAllDocuments($event)" style="position: relative; z-index: 1;"></th>

                            <!-- href z sort= tylko dla table-layout.js (rozpoznaje po nim kolumny naglowka);
                                 sortujemy lokalnie, bez przeladowania -->
                            <th v-for="column in columnsSelected" class="sticky-header text-center">
                                <!-- th-link jak w @sortablelink (config/columnsortable.php) - kolor ze skorki -->
                                <a class="th-link" :href="'?sort=' + column" @click.prevent="sortTable(column)">{{ getTrans(column) }}<template v-if="column == sortColumn">&nbsp;<i :class="sortDirection == 'desc'? 'fas fa-long-arrow-alt-up' : 'fas fa-long-arrow-alt-down'"></i></template></a>
                            </th>

                            <th class="th-last w-20 sticky-header"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="row-click row-show" v-for="document in sortedDocuments" :key="document.id">
                            <td class="td-padding wrap-text-inside-td">
                                <input type="checkbox" v-model="document.checked" style="position: relative; z-index: 1;">
                            </td>
                            <td v-for="column in columnsSelected" class="td-padding text-nowrap" :class="{'text-right':isMoney(column)|| column == 'real_payment_in_days' || column=='payment_term_in_days'}">
                                <wrapped-text v-if="textRule(column)" :text="getValue(column, document)" :line_max="textRule(column).line"
                                              :wrap_on_space="textRule(column).wrap" :max_length="textRule(column).max"/>
                                <template v-else>{{getValue(column, document)}}</template>
                            </td>
                            <!-- odpowiednik th-last - table-layout.js przypina tylko wiersze z ta sama liczba komorek co naglowek -->
                            <td></td>
                        </tr>
                        </tbody>
                    </table>
        </div>
        <div class="ibox-content">
            <div v-if="analyzeType == 'sell' ? access.export_sell : access.export_buy">
                {{ __('with_selected') }}:
                <b-dropdown :text="__('export')" size="sm" class="mb-0 export-button" variant="primary">
                    <b-dropdown-item  @click="bulkAction('export-xls')">XLS</b-dropdown-item>
                    <b-dropdown-item  @click="bulkAction('export-pdf')">PDF</b-dropdown-item>
                    <b-dropdown-item  @click="bulkAction('export-csv')">CSV</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
    </div>


</template>

<script>
import {getTransForAnalyze, ANALYZE_COLUMN_TEXT_RULES} from "./mixin";
import {Money} from '../../services/Money';
export default {
    name: "ListPositionComponent",
    mixins: [getTransForAnalyze],
    data: function () {
        return {
            modal_visible:false,
            money: new Money(),
            sortColumn: this.tableSort ? this.tableSort.column : null, // Kolumna, według której sortujemy
            sortDirection: this.tableSort ? this.tableSort.direction : 'asc', // Kierunek sortowania (asc lub desc)
        }
    },

    props: {
        analyzeType: {
            type: String
        },
        columnsSelected:{
            type: Array
        },
        columnsNotSelected:{
            type: Array
        },
        // domyslne sortowanie z ustawien tabeli (user_columns)
        tableSort:{
            type: Object,
            default: null
        },
        documents: {
            type: Array
        },
        access:{
            type: Object
        }
    },
    methods:{
        toggleAllDocuments(event) {
            const isChecked = event.target.checked;
            this.$emit('toggle-all', isChecked);
        },
        bulkAction: function(type) {
            toggleLoader()
            let documentsToExport = [];
            let ext = type.split('-').pop();
            let documentItemIds = this.documents.filter(item=>{
                return item.checked == true;
            })
            if(documentItemIds.length > 0){
                documentsToExport = documentItemIds;
            }
            else{
                documentsToExport = this.documents
            }
            const formData = new FormData();
            documentsToExport.forEach((obj, index) => {
                formData.append(`id[${index}]`, obj.id);
            });
            this.columnsSelected.forEach((obj, index) => {
                formData.append(`columns[${index}]`, obj);
            });
            formData.append('area', this.analyzeType)
            formData.append('action_type', type)
            this.axios({
                method: 'post',
                url: "/analyze/bulk-action",
                data: formData,
                responseType: 'blob',
            }).then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                var dt = new Date();
                var file_name = 'export_' + (`${
                        dt.getFullYear().toString().padStart(4, '0')}_${
                        (dt.getMonth()+1).toString().padStart(2, '0')}_${
                        dt.getDate().toString().padStart(2, '0')}_${
                        dt.getHours().toString().padStart(2, '0')}${
                        dt.getMinutes().toString().padStart(2, '0')}${
                        dt.getSeconds().toString().padStart(2, '0')}`
                )+'.';
                link.setAttribute('download', file_name + ext);
                document.body.appendChild(link);
                link.click();
                toggleLoader(false)
            });
        },
        toggleVisible(){
            this.$emit('showModal');
        },
        getTrans(column){
            return this.getTransColumn(column)
        },
        isMoney(column){
            return this.isMoneyFormat(column)
        },
        textRule(column){
            return ANALYZE_COLUMN_TEXT_RULES[column] || null;
        },
        refreshTableLayout(){
            this.$nextTick(function () {
                if (window.tableLayout) window.tableLayout.refresh();
            });
        },
        getValue(column, document, notSort = true){
            if(column.includes('_id')){
                column = column.replace('_id', '_display');
            }
            if(this.isMoney(column) && notSort){
                if(document[column] !== '' && document[column] != '-' && document[column] != null){
                    return this.money.localize(document[column])
                }
                return '-';
            }
            else{
                return document[column];
            }
        },
        sortTable(column) {
            if (this.sortColumn === column) {
                // Jeśli kliknięto na aktualną kolumnę, zmień kierunek sortowania
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                // Jeśli kliknięto na inną kolumnę, zresetuj kierunek sortowania
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }
        },
    },
    watch:{
        tableSort(sort){
            this.sortColumn = sort ? sort.column : null;
            this.sortDirection = sort ? sort.direction : 'asc';
        }
    },
    // przypiecia kolumn (table-layout.js) naklada klasy na komorki - po kazdym przerysowaniu od nowa
    mounted(){
        this.refreshTableLayout();
    },
    updated(){
        this.refreshTableLayout();
    },
    computed:{
        sortedDocuments() {
            if (!this.sortColumn) {
                return this.documents;
            }
            return this.documents.slice().sort((a, b) => {
                const valueA = this.getValue(this.sortColumn, a, false) || ''; // Domyślnie pusty łańcuch, jeśli wartość jest null
                const valueB = this.getValue(this.sortColumn, b, false) || ''; // Domyślnie pusty łańcuch, jeśli wartość jest null
                if (this.sortDirection === 'asc') {
                    if(this.isMoney(this.sortColumn)){
                        return valueA - valueB;
                    }
                    return valueA.localeCompare(valueB);
                } else {
                    if(this.isMoney(this.sortColumn)){
                        return valueB - valueA;
                    }
                    return valueB.localeCompare(valueA);
                }
            });
        },
    },
}
</script>

<style scoped>
.sticky-header {
    position: -webkit-sticky;
    position: sticky;
    top: 55px;
    z-index: 2; /* Opcjonalne: Jeśli masz inne elementy z wyższym z-index, aby nagłówki były na wierzchu */
}
/* Po przypieciu kolumn table-layout.js wklada tabele w kontener z przewijaniem poziomym - on staje sie
   wtedy odniesieniem dla sticky i top przesuwal naglowek w dol pod pierwszy wiersz. Przyklejony naglowek
   zapewnia wtedy kopia z table-layout.js (.table-sticky-head), a przypiete kolumny trzymaja sie w poziomie. */
.table-hscroll .sticky-header {
    top: auto;
}
</style>
